import Cookies from 'js-cookie';

const SESSION_COOKIE = 'cw_d_session_info';

// Not a security hash: it only needs to be stable and collision free enough to
// keep two people apart, while keeping the email itself out of a database name
// that shows up in devtools.
const fingerprint = value => {
  let hash = 5381;
  for (let i = 0; i < value.length; i += 1) {
    // eslint-disable-next-line no-bitwise
    hash = (hash * 33) ^ value.charCodeAt(i);
  }
  // eslint-disable-next-line no-bitwise
  return (hash >>> 0).toString(36);
};

// The cached models (inbox, team, label, canned response) are filtered per user
// by the access rules, so the browser store cannot be shared between the people
// who sign in on the same machine. The devise session cookie carries `uid`,
// which is set before the dashboard makes its first request, so it is readable
// synchronously and without pulling the store into this module.
export const currentUserCacheId = () => {
  let uid = '';

  try {
    uid = JSON.parse(Cookies.get(SESSION_COOKIE) || '{}').uid || '';
  } catch {
    uid = '';
  }

  return uid ? fingerprint(String(uid)) : 'anon';
};

export default currentUserCacheId;
